// JOBE-0105: aggregations.js — pure helpers for the projects-index side rail.
//
// `topNByKey` groups an array of rows by a key extracted via a `keyOf`
// function and returns the top-N {key, count} entries sorted by count
// descending, with ties broken by ascending key.
//
// Empty / nullish keys are dropped by default (rows with no `assignedTo`
// should not aggregate into a `''` bucket) — pass
// `{ includeEmpty: true }` to surface them as a single `'<none>'` bucket.

export function topNByKey(rows, keyOf, n = 5, opts = {}) {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  const { includeEmpty = false, emptyLabel = '<none>' } = opts;
  const counts = new Map();
  for (const row of rows) {
    let key;
    try {
      key = keyOf(row);
    } catch {
      key = '';
    }
    if (key === undefined || key === null || key === '') {
      if (!includeEmpty) continue;
      key = emptyLabel;
    }
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  const entries = Array.from(counts.entries()).map(([key, count]) => ({ key, count }));
  entries.sort((a, b) => {
    if (b.count !== a.count) return b.count - a.count;
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });
  return entries.slice(0, Math.max(0, n));
}
